import { render, staticRenderFns } from "./EventGuestList.vue?vue&type=template&id=3cbcb45f&scoped=true"
import script from "./EventGuestList.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventGuestList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventGuestList.vue?vue&type=style&index=0&id=3cbcb45f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbcb45f",
  null
  
)

export default component.exports